import { IBaseQueryParameters } from '../index.js'

/**
 * This interface defines the path parameters for the endpoints available in the
 * `Member` endpoint class.
 */
export interface IMemberPathParameters extends IBaseQueryParameters {
  /** The unique identifier that matches a given member of Congress. */
  bioguideId?: string
}
